module.exports = __webpack_public_path__ + "static/media/icon-help.fd4c392f.svg";